// route.js
import React, { lazy } from "react";
import { Route, Routes } from "react-router-dom";
import Layout from "../Component/Layout/AppLayout";
import UserProfile from "../Component/Dashboard/UserProfile";
import EditUserProfile from "../Component/Dashboard/EditUserProfile";
import Protected from "../Component/Protected";
import Fallback from "./Error";
import { ErrorBoundary } from "react-error-boundary";
const LoginForm = lazy(() => import("../Component/Login/LoginForm"));
const ForgotPasswordForm = lazy(() => import("../Component/Login/ForgotForm"));
const DashboardPage = lazy(() => import("../Component/Dashboard/Dashboard"));
const ResetPasswordForm = lazy(() => import("../Component/Login/ResetPasswordForm"));
const Confirmation = lazy(() => import("../Component/Login/Confirmation"));
const CustomerView = lazy(() => import("../Component/Customer/CustomerView"));
const ProjectPage = lazy(() => import("../Component/Project/ProjectList"));
const UserPage = lazy(() => import("../Component/Users/UserList"));
const ProjectDetail = lazy(() => import("../Component/Project/ProjectDetail"));
const UserDetail = lazy(() => import("../Component/Users/UserDetail"));
const CustomerList = lazy(() => import("../Component/Customer/CustomerList"));
const CustomerServiceQuestion = lazy(() => import("../Component/Customer/CustomerServiceQuestion"));
const SignInForm = lazy(() => import("../Component/Login/SignIn"));
const Agreements = lazy(() => import("../Component/Agreements/Agreements"));
const PaymentHistory = lazy(() => import("../Component/Reports/PaymentHistory"));
const AbandonedCart = lazy(() => import("../Component/Reports/AbandonedCart"));
const UserRoles = lazy(() => import("../Component/Users/UserRoles"));
const SingleMemberLLC = lazy(() => import("../Component/LegalTools/SingleMemberLLC"));
const SingleMemberServiceQuestion = lazy(() => import("../Component/LegalTools/SingleMemberLLCView"))


const RoutesConfig = () => {

  return (

    <ErrorBoundary FallbackComponent={Fallback}>

    <Routes>

      <Route exact path="/" element={<LoginForm />} />
      <Route exact path="/forgot-password" element={<ForgotPasswordForm />} />
      <Route exact path="/resetpasswordform/:id" element={<ResetPasswordForm />} />
      <Route exact path="/confirmation" element={<Confirmation />} />
      <Route exact path="/signin/:id" element={<SignInForm />} />
      <Route exact path="/applayout" element={<Layout />} />


      <Route
        exact
        path="/dashboard"
        element={<Protected Component={DashboardPage} navigation={'dashboard'} />}
      />

      <Route
        exact
        path="/clients/:serviceId"
        element={<Protected Component={CustomerList} navigation={'clients/:serviceId'} />}
      />

      <Route
        exact
        path="/userprofile"
        element={<Protected Component={UserProfile} navigation={'userprofile'} />}
      />

      <Route
        exact
        path="/edituserprofile"
        element={<Protected Component={EditUserProfile} navigation={'edituserprofile'} />}
      />

      <Route
        exact
        path="/clientview/:id"
        element={<Protected Component={CustomerView} navigation={'clientview/:id'} />}
      />

      <Route
        exact
        path="/clientservicequestion/:serviceId/:customerId"
        element={<Protected Component={CustomerServiceQuestion} navigation={'clientservicequestion/:serviceId/:customerId'} />}
      />

      <Route
        exact
        path="/singlememberservicequestion/:serviceId/:customerId"
        element={<Protected Component={SingleMemberServiceQuestion} navigation={'singlememberservicequestion/:serviceId/:customerId'} />}
      />

      <Route
        exact
        path="/legaltools"
        element={<Protected Component={ProjectPage} navigation={'legaltools'} />}
      />

      <Route
        exact
        path="/legaltoolsdetail/:id"
        element={<Protected Component={ProjectDetail} navigation={'legaltoolsdetail/:id'} />}
      />

      <Route
        exact
        path="/userlist"
        element={<Protected Component={UserPage} navigation={'userlist'} />}
      />

      <Route
        exact
        path="/userdetail/:id"
        element={<Protected Component={UserDetail} navigation={'userdetail/:id'} />}
      />

      <Route
        exact
        path="/agreements"
        element={<Protected Component={Agreements} navigation={'agreements'} />}
      />

      <Route
        exact
        path="/paymenthistory"
        element={<Protected Component={PaymentHistory} navigation={'paymenthistory'} />}
      />

      <Route
        exact
        path="/abandonedcart"
        element={<Protected Component={AbandonedCart} navigation={'abandonedcart'} />}
      />

      <Route
        exact
        path="/userroles"
        element={<Protected Component={UserRoles} navigation={'userroles'} />}
      />
      <Route
        exact
        path="/legaltools/:serviceName/:serviceId"
        element={<Protected Component={SingleMemberLLC} navigation={'legaltools/:serviceName/:serviceId'} />}
      />

      <Route path="*" element={<LoginForm />} />


    </Routes>
    </ErrorBoundary>

  );
};

export default RoutesConfig;
